/*------------------------------------*\
    MODULES
\*------------------------------------*/


/*------------------------------------*\
    HAMBURGER MODULE
\*------------------------------------*/
class Hamburger {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;
        self.toogle();
        self.active();
    }

    toogle() {
        let self = this;
        let hamburger = document.querySelector('.hamburger');
        let navigation = document.querySelector('.site-head__navigation');
        let siteHead = document.querySelector('.site-head');
        let body = document.querySelector('body');
        let status = false;

        let expand = () => {
            if (!status) {
                hamburger.setAttribute("aria-expanded", true)
                navigation.setAttribute("aria-expanded", true)
                siteHead.style.overflowX = "visible";
                siteHead.style.overflowY = "visible";
                body.style.position = "fixed";
                status = true
            } else if (status) {
                hamburger.setAttribute("aria-expanded", false)
                navigation.setAttribute("aria-expanded", false)
                siteHead.style.overflowX = "hidden";
                siteHead.style.overflowY = "hidden";
                body.style.position = "relative";
                status = false
            }
        }

        let close = () => {
            if (status && window.innerWidth < 991) {
                navigation.setAttribute("aria-expanded", false)
                hamburger.setAttribute("aria-expanded", false)
                body.style.position = "relative";
                status = false
            }
        }

        hamburger.addEventListener("click", expand);
    }

    active() {
        let self = this;
        let listItems = document.querySelectorAll('.site-head__list-item');
        let listItemsLink = document.querySelectorAll('.site-head__list-item-link');
        let listItemsFooter = document.querySelectorAll('.site-foot__list-item');
        let listItemsLinkFooter = document.querySelectorAll('.site-foot__list-item-link');

        for (let index = 0; index < listItemsLink.length; index++) {
            if (window.location.pathname == listItemsLink[index].getAttribute('href') + '/') {
                listItems[index].classList.add('site-head__list-item--active');
            }
        }

        for (let index = 0; index < listItemsLinkFooter.length; index++) {
            if (window.location.pathname == listItemsLinkFooter[index].getAttribute('href') + '/') {
                listItemsFooter[index].classList.add('site-foot__list-item--active');
            } else if (window.location.pathname == '' + '/') {
                listItemsFooter[0].classList.add('site-foot__list-item--active');
            }
        }
    }

}

export default Hamburger;